import { useFormik } from 'formik';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Button, InputField } from '@scramble/ui';
import IconEmail from '@scramble/design-system/icons/mail-01.svg?react';
import s from '../index.module.scss';

const getValidationSchema = t =>
  Yup.object().shape({
    email: Yup.string()
      .strictEmail(t('validation:invalid_email'))
      .max(50, t('validation:invalid_email'))
      .required(t('validation:please_enter_email')),
  });

export const EmailForm = ({ captchaLoaded, children, onSubmit }) => {
  const { t } = useTranslation();

  const { values, setFieldValue, errors, touched, isSubmitting, handleSubmit } =
    useFormik({
      validationSchema: getValidationSchema(t),
      onSubmit,
      initialValues: {
        email: '',
      },
    });

  return (
    <form className={s.form} onSubmit={handleSubmit}>
      <InputField
        label={t('auth:step_main.email')}
        id="email"
        name="email"
        value={values.email}
        placeholder={t('auth:step_main.email_placeholder')}
        onClear={() => setFieldValue('email', '')}
        onChange={e => setFieldValue('email', e.target.value.trim())}
        leftContainer={({ focused }) => (
          <IconEmail
            className={classnames(s.icon_mail, focused && s.icon_mail_focused)}
          />
        )}
        error={errors.email && touched.email && errors.email}
      />
      {children}
      <Button
        type="submit"
        theme="brand"
        appearance="filled"
        size="lg"
        label={t('auth:step_main.continue_with_email')}
        disabled={!captchaLoaded || isSubmitting}
      />
    </form>
  );
};
